import { render, staticRenderFns } from "./LiveRoom.vue?vue&type=template&id=9c43132c&scoped=true&"
import script from "./LiveRoom.vue?vue&type=script&lang=js&"
export * from "./LiveRoom.vue?vue&type=script&lang=js&"
import style0 from "./LiveRoom.vue?vue&type=style&index=0&id=9c43132c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c43132c",
  null
  
)

export default component.exports